import { get } from "lodash";
import * as React from "react";
import { cloneElement } from "react";
import { sanitizeListRestProps, TopToolbar } from "react-admin";
import CreateButton from "../components/buttons/CreateButton";

const Actions = ({ isAdmin, ...props }) => {
	const { className, filters, resource, basePath, ...rest } = props;
	const bookmakerTypeId = get(props, "filterValues.bookmaker_type_id");
	return (
		<TopToolbar className={className} {...sanitizeListRestProps(rest)}>
			{cloneElement(filters, { context: "button" })}
			<CreateButton
				resource={resource}
				basePath={basePath}
				baseRecord={{ bookmaker_type_id: bookmakerTypeId }}
			/>
		</TopToolbar>
	);
};

export default Actions;
